module.exports = __webpack_public_path__ + "static/logo_sei_top-f7bb435b2ee6f4dc5d94b60209f18315.png";